'use client';

import { useBreakpointMax } from '@/theme';
import Box from '../ui/Box';
import Txt, { TxtProps } from '../ui/Txt';

type FooterCompanyInformationProps = TxtProps<
  'span',
  {
    label?: string | null;
    enableMobile?: boolean;
  }
>;

export default function FooterCompanyInformation({
  label,
  enableMobile,
  ...props
}: FooterCompanyInformationProps) {
  const md = useBreakpointMax('md');

  const inner = label && (
    <Box>
      <Txt html {...props}>
        {label}
      </Txt>
    </Box>
  );

  if (enableMobile) {
    return md ? inner : null;
  }

  if (!enableMobile) {
    return md ? null : inner;
  }
}
